import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Button, TextField, Grid, Paper, Typography } from '@mui/material';
import axios from 'axios';
import { API } from '../controller/api';

const ResetPassword = () => {
  const [token, setToken] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const location = useLocation();
  const navigate = useNavigate();

  useEffect (() => {
    const params = new URLSearchParams(location.search);
    const tokenFromQuery = params.get('a');
    if (tokenFromQuery) {
      setToken(tokenFromQuery);
    }
  }, [location.search]);

  const handleResetPassword = async () => {
    if (password !== confirmPassword) {
      setMessage("Passwords don't match.");
      return;
    }

    try {
      const response = await axios.post(`${API}/auth/reset-password`, { token, password });
      setMessage('Password has been reset. You can now log in with your new password.');
      setTimeout(() => navigate('/login'), 3000); // Redirect after a delay
    } catch (error) {
      setMessage('Error resetting password. Please try again.');
    }
  };

  return (
    <Grid 
      container 
      spacing={0} 
      direction="column" 
      alignItems="center" 
      justifyContent="center" 
      style={{ minHeight: '100vh', backgroundColor: '#074B79' }}
    >
      <Grid item xs={12}>
        <Paper 
          elevation={3} 
          style={{ padding: '2rem', textAlign: 'center', maxWidth: 350, backgroundColor: 'white' }}
        >
          <Typography variant="h6" gutterBottom>
            Reset Password
          </Typography>
          <TextField
            fullWidth
            label="New Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <TextField
            fullWidth
            label="Confirm New Password"
            type="password"
            variant="outlined"
            margin="normal"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          <Button 
            variant="contained" 
            fullWidth 
            onClick={handleResetPassword}
            style={{ backgroundColor: '#0077B6', color: 'white', marginTop: '1rem' }}
          >
            Reset Password
          </Button>
          {message && (
            <Typography variant="body2" style={{ color: '#0077B6', marginTop: '1rem' }}>
              {message}
            </Typography>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ResetPassword;
